import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from '@douyinfe/semi-ui';
import Title from '@douyinfe/semi-ui/lib/es/typography/title';
import Text from '@douyinfe/semi-ui/lib/es/typography/text';
import { API, showError, showInfo, showSuccess } from '../helpers';
import Turnstile from 'react-turnstile';

const PasswordResetForm = () => {
  const [inputs, setInputs] = useState({
    email: ''
  });
  const { email } = inputs;

  const [loading, setLoading] = useState(false);
  const [turnstileEnabled, setTurnstileEnabled] = useState(false);
  const [turnstileSiteKey, setTurnstileSiteKey] = useState('');
  const [turnstileToken, setTurnstileToken] = useState('');
  const [disableButton, setDisableButton] = useState(false);
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    let countdownInterval = null;
    if (disableButton && countdown > 0) {
      countdownInterval = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setDisableButton(false);
      setCountdown(30);
    }
    return () => clearInterval(countdownInterval);
  }, [disableButton, countdown]);

  useEffect(() => {
    let status = localStorage.getItem('status');
    if (status) {
      status = JSON.parse(status);
      if (status.turnstile_check) {
        setTurnstileEnabled(true);
        setTurnstileSiteKey(status.turnstile_site_key);
      }
    }
  }, []);

  function handleChange(name, value) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }

  async function handleSubmit(e) {
    setDisableButton(true);
    if (!email) return;
    if (turnstileEnabled && turnstileToken === '') {
      showInfo('请稍后几秒重试，Turnstile 正在检查用户环境！');
      return;
    }
    setLoading(true);
    const res = await API.get(
      `/api/reset_password?email=${email}&turnstile=${turnstileToken}`
    );
    const { success, message } = res.data;
    if (success) {
      showSuccess('重置邮件发送成功，请检查邮箱！');
      setInputs({ ...inputs, email: '' });
    } else {
      showError(message);
    }
    setLoading(false);
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f5f7fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '480px' }}>
        {/* Logo 和标题 */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '32px'
        }}>
          <Title heading={2} style={{ 
            margin: 0, 
            color: '#303133',
            fontWeight: '600'
          }}>
            密码重置
          </Title>
          <Text style={{ 
            color: '#909399', 
            marginTop: '8px',
            fontSize: '14px'
          }}>
            输入您的邮箱以接收密码重置链接
          </Text>
        </div>

        <Card 
          style={{ 
            boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            border: '1px solid #e4e7ed'
          }}
        >
          <div style={{ padding: '32px' }}>
            <Form>
              <Form.Input
                field={'email'}
                label={'邮箱地址'}
                placeholder="请输入您的邮箱"
                name="email"
                type="email"
                size="large"
                value={email}
                style={{ marginBottom: '20px' }}
                onChange={(value) => handleChange('email', value)}
              />
              {turnstileEnabled && (
                <div style={{ marginBottom: '20px' }}>
                  <Turnstile
                    sitekey={turnstileSiteKey}
                    onVerify={(token) => {
                      setTurnstileToken(token);
                    }}
                  />
                </div>
              )}
              <Button 
                theme="solid" 
                style={{ 
                  width: '100%',
                  background: '#409eff',
                  border: 'none',
                  height: '40px',
                  fontSize: '14px',
                  fontWeight: '500',
                  borderRadius: '4px'
                }} 
                type={'primary'} 
                size="large"
                loading={loading}
                disabled={disableButton}
                onClick={handleSubmit}>
                {disableButton ? `重试 (${countdown})` : '提交'}
              </Button>
            </Form>
          </div>
        </Card>

        {/* 底部版权信息 */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '32px',
          color: '#c0c4cc',
          fontSize: '12px'
        }}>
          © 2026 AI API Platform. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default PasswordResetForm;
